<template>
  <div class="pc" ref="pc" @wheel="pcScroll">
    <div class="top top-fixed">
      <div class="left">
        <img src="../images/logo-big.png" alt="">
        <p>面向终身学习的优质学习内容及服务提供商</p>
      </div>
      <div class="right">
        <p :class="{'current': scrollIndex === 0}" @click="scrollToPage(0)">善版无影AI学习电脑</p>
        <p :class="{'current': scrollIndex === 1}" @click="scrollToPage(1)">善版智能学习书 </p>
        <p :class="{'current': scrollIndex === 2}" @click="scrollToPage(2)">善版知盟</p>
        <p :class="{'current': scrollIndex >= 3}" @click="scrollToPage(3)">善版优质内容浏览器</p>
      </div>
    </div>
    <div class="dots">
      <div class="dot" :class="{'current': scrollIndex === 0}" @click="scrollToPage(0)"></div>
      <div class="dot" :class="{'current': scrollIndex === 1}" @click="scrollToPage(1)"></div>
      <div class="dot" :class="{'current': scrollIndex === 2}" @click="scrollToPage(2)"></div>
      <div class="dot" :class="{'current': scrollIndex >= 3}" @click="scrollToPage(3)"></div>
    </div>
    <div class="banner banner1">
      <img v-intersect class="img1-1" src="../images/t1.png" alt="">
      <img v-intersect class="img1-2" src="../images/t2.png" alt="">
    </div>
    <div class="banner banner2">
      <img v-intersect class="img2-1" src="../images/t3.png" alt="">
      <img v-intersect class="img2-2" src="../images/t7.png" alt="">
    </div>
    <div class="banner banner3">
      <img v-intersect class="img3-1" src="../images/t4.png" alt="">
      <img v-intersect class="img3-2" src="../images/t6.png" alt="">
      <p v-intersect class="text3-1">善版知盟（SKSA,Shanban Knowledge Service Alliance ）是善版云知识服务生态联盟，旨在与合作伙伴一起，推进数智出版产业发展，<br/>为用户打造极致性价比的终身学习产品，让每一位学习者都能享有学习的权利，把优质学习内容带给每一位学习者。</p>
    </div>
    <div class="banner banner4">
      <div class="left" v-intersect>
        <img class="img4-1" src="../images/logo-small.png" alt="">
        <img class="img4-2" src="../images/t5.png" alt="">
        <img class="img4-3" src="../images/code.png" alt="">
      </div>
      <div class="right">
        <p v-intersect class="text4-1">让优质学习内容触手可及</p>
        <p v-intersect class="text4-2">善版云App是一款专注于优质学习内容的浏览器。用户通过善版云App可以访问合作出版社的官网，浏览出版社官网的智能学习书以及其他丰富的数字学习内容。善版云App通过严格的内容筛选只允许用户访问指定的优质学习内容，进而为用户提供纯净安全的学习体验。同时，善版云App通过AI智能技术，为用户提供多种多样的学习互动模块、科学合理的学习路径规划以及有趣高效的学习激励系统，帮助用户大幅提升学习效果。</p>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <p>Copyright © 2024 北京善版科技有限公司</p>
        <p>京公网安备 11010802041724号</p>
        <p style="cursor: pointer;" @click="toBeiAn">京ICP备2023005786号</p>
        <p>增值电信业务经营许可证：京B2-20243662</p>
        <p>隐私声明</p>
        <p>关于cookies</p>
        <p>联系我们</p>
        <p>地址：北京市海淀区中关村大街22号5层508</p>
      </div>
      <p class="tel"><img src="../images/tel.png" alt="">400-998-0026</p>
      <p class="wechat"><img src="../images/bottom-wechat.png" alt=""></p>
      <p class="weibo"><img src="../images/bottom-weibo.png" alt=""></p>
      <p class="phone"><img src="../images/bottom-phone.png" alt=""></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  directives: {
    // 自定义指令, 滚动到指定位置
    intersect: {
      bind(el) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('fade-in-animation');
                // 如果你希望动画只播放一次，取消下面的注释
                // observer.unobserve(el);
              } else {
                // 当元素离开视图区域后，移除动画类，以便再次进入时重新触发动画
                el.classList.remove('fade-in-animation');
              }
            });
          }
        )
        observer.observe(el);
      }
    }
  },
  data() {
    return {
      scrollIndex: 0, // 上次滚动条位置
      isScrolling: false,
      isMac: false
    }
  },
  watch: {
    // 监听滚动条位置
    scrollIndex(val) {
      this.isScrolling = true
      if (window.pcScrollChangeTimer) {
        clearTimeout(window.pcScrollChangeTimer)
      }
      window.pcScrollChangeTimer = setTimeout(() => {
        this.isScrolling = false
        window.pcScrollChangeTimer = null
      }, this.isMac ? 1500 : 500)
      this.$refs.pc.scrollTo({
        top: document.documentElement.clientHeight * val,
        behavior: 'smooth'
      })
    }
  },
  created() {
    // 监听上下箭头按键
    document.onkeydown = (e) => {
      if (e.keyCode === 40 || e.keyCode === 32) {
        // 向下滚动
        if (this.scrollIndex < 4) {
          this.scrollIndex++
        }
      } else if (e.keyCode === 38) {
        // 向上滚动
        if (this.scrollIndex > 0) {
          this.scrollIndex--
        }
      }
    }
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase()
    this.isMac = ua.indexOf('mac') > -1 && ua.indexOf('windows') === -1 // 判断是否是mac
  },
  methods: {
    // pc滚动事件
    pcScroll(e) {
      e.preventDefault() // 阻止事件冒泡
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.returnValue = false;
      }
      if (this.isScrolling) {
        return
      }
      if (e.deltaY > 0) {
        // 向下滚动
        if (this.scrollIndex < 4) {
          this.scrollIndex++
        }
      } else {
        // 向上滚动
        if (this.scrollIndex > 0) {
          this.scrollIndex--
        }
      }
    },
    scrollToPage(index) {
      this.scrollIndex = index
    },
    toBeiAn() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(0.3rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in-animation {
  animation: fadeIn 1s forwards;
}
@keyframes topShow {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.pc {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .top {
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    height: 0.9rem;
    padding: 0rem 3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    &.top-absolute {
      position: absolute;
    }
    &.top-fixed {
      position: fixed;
      // background-color: rgba(0, 0, 0, 0.7);
      animation: topShow 0.3s forwards;
    }
    .left {
      display: flex;
      align-items: center;
      img {
        width: 0.69rem;
      }
      p {
        color: #FEFEFE;
        font-size: 0.15rem;
        line-height: 0.26rem;
        margin-left: 0.35rem;
      }
    }
    .right {
      display: flex;
      align-items: center;
      color: rgba(254, 254, 254, 0.37);
      font-size: 0.15rem;
      line-height: 0.15rem;
      p {
        padding: 0rem 0.18rem;
        border-right: 0.01rem solid rgba(255, 255, 255, 0.37);
        cursor: pointer;
        &:last-child {
          border-right: none;
        }
        &.current {
          color: #fefefe;
        }
        &:hover {
          color: #fefefe;
        }
      }
    }
  }
  .dots {
    position: fixed;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    .dot {
      width: 0.1rem;
      height: 0.1rem;
      background-color: #fff;
      border-radius: 50%;
      margin-bottom: 0.2rem;
      cursor: pointer;
      opacity: 0.15;
      &.current {
        opacity: 0.7;
      }
    }
  }
  .banner {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &.banner1 {
      // background-image: url(../images/bg1.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726625128167.png');
      padding-top: 5vh;
      .img1-1 {
        width: 10rem;
      }
      .img1-2 {
        width: 8.08rem;
        margin-top: 28vh;
      }
    }
    &.banner2 {
      // background-image: url(../images/bg2.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474570673.png');
      padding-top: 23vh;
      .img2-1 {
        width: 9.44rem;
        margin-left: 0.5rem;
      }
      .img2-2 {
        width: 13.25rem;
        margin-top: 24vh;
      }
    }
    &.banner3 {
      // background-image: url(../images/bg3.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474588859.png');
      padding-top: 10vh;
      .img3-1 {
        width: 4.7rem;
      }
      .img3-2 {
        width: 8.99rem;
        margin-top: 10vh;
        margin-bottom: 20vh;
      }
      .text3-1 {
        color: #fff;
        font-size: 0.16rem;
        line-height: 0.26rem;
        width: 10.8rem;
        letter-spacing: 0.01rem;
      }
    }
    &.banner4 {
      // background-image: url(../images/bg4.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474600226.png');
      flex-direction: row;
      .left {
        width: 36.8%;
        padding-left: 3rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        .img4-1 {
          width: 1.43rem;
          margin-top: 4vh;
        }
        .img4-2 {
          width: 3.02rem;
          margin-top: 0.42rem;
        }
        .img4-3 {
          width: 2.27rem;
          margin-top: 18.3vh;
        }
      }
      .right {
        flex: 1;
        height: 100vh;
        margin-left: 0.7rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        color: white;
        .text4-1 {
          font-size: 0.4rem;
          margin-bottom: 0.24rem;
        }
        .text4-2 {
          margin-bottom: 0.8rem;
          font-size: 0.16rem;
          line-height: 0.25rem;
          width: 8.2rem;
          color: rgba(255, 255, 255, 0.7);
          text-align: justify;
          letter-spacing: 0.01rem;
        }
      }
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    height: 1.42rem;
    background-color: #1F1F1F;
    padding: 0px 50px;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      > p {
        color: #9A9A9A;
        font-size: 0.15rem;
        line-height: 0.26rem;
        margin-right: 0.2rem;
        white-space: nowrap;
      }
    }
    > p {
      color: #9A9A9A;
      font-size: 0.15rem;
      line-height: 0.26rem;
      margin-right: 0.2rem;
      white-space: nowrap;
      &:last-child {
        margin-right: 0 !important;
      }
      &.tel {
        display: flex;
        align-items: center;
        padding: 0rem 0.33rem 0rem 0.5rem;
        img {
          width: 0.14rem;
          margin-right: 0.05rem;
        }
      }
      &.wechat, &.weibo, &.phone {
        margin-right: 0.32rem;
        img {
          height: 0.22rem;
        }
      }
    }
  }
}
</style>
